<template>
  <ubi-page-container class="ubi-panel" :v-loading="loadingStatus">
    <PostEditoCreateModalConfirmStopCustom></PostEditoCreateModalConfirmStopCustom>
    <dialog-planif-post-editorial :post="post"></dialog-planif-post-editorial>
    <post-edito-create-modal-i-a :post="post"></post-edito-create-modal-i-a>
    <dialog-publish-now :post="post"></dialog-publish-now>
    <dialog-delete-planif-brouillon></dialog-delete-planif-brouillon>
    <el-container>
      <el-form :model="post" :rules="rules" ref="formEdito" label-width="120px">
        <el-row>
          <el-col :lg="12">
            <post-edito-create-publication-initiale @updateValue="setError" :post="post"></post-edito-create-publication-initiale>
          </el-col>
          <el-col :lg="12">
            <post-edito-create-facebook :post="post"></post-edito-create-facebook>
            <post-edito-create-instagram :post="post"></post-edito-create-instagram>
            <post-edito-create-google :post="post"></post-edito-create-google>
            <post-edito-create-linkedin :post="post"></post-edito-create-linkedin>
          </el-col>
        </el-row>
      </el-form>

    </el-container>
    <template v-if="browserContext.up('md')">
      <hr/>
      <div class="text-right">
        <el-row>
          <el-button type="warning" v-if="(edit && post.etat && (post.etat === 'A' || post.etat === 'M'))" @click="onSubmit(post.etat)" :disabled="draftButtonAvailable">
            Enregistrer les modifications
          </el-button>
          <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.validator.fieldsRequired')"
                      placement="bottom" v-if="draftButtonAvailable && !model">
            <el-button :disabled="draftButtonAvailable" type="danger">{{$t('socialPosts.create.saveDraft')}}</el-button>
          </el-tooltip>
          <el-button type="danger" @click="onSubmit('B')" :disabled="draftButtonAvailable" v-else>{{$t('socialPosts.create.saveDraft')}}</el-button>

          <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.validator.fieldsRequiredComplete')"
                      placement="bottom" v-if="publishButtonAvailable && !model">
            <el-button type="success" :disabled="publishButtonAvailable" @click="onSubmit('A')">{{$t('socialPosts.create.core.publish')}}</el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.validator.fieldsRequired')"
                      placement="bottom" v-else-if="draftButtonAvailable && !publishButtonAvailable && !model">
            <el-button type="success" :disabled="draftButtonAvailable" @click="onSubmit('A')">{{$t('socialPosts.create.core.publish')}}</el-button>
          </el-tooltip>

          <el-dropdown placement="top" @command="handleplanningActions" v-else-if="!model">
            <el-button type="success" :disabled="publishButtonAvailable" style="margin-left: 10px">
              {{$t('socialPosts.create.core.publish')}}
            </el-button>
            <el-dropdown-menu slot="dropdown" v-if="!model">
              <el-dropdown-item command="schedule"><i class="el-icon-date"></i> {{$t('general.calendar.scheduled')}}</el-dropdown-item>
              <el-dropdown-item command="publishNow"><i class="el-icon-share"></i> {{$t('general.calendar.publishNow')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-else-if="model" type="success" @click="onSubmit('M')">{{ $t('socialPosts.models.saveModel') }}</el-button>
          <el-button @click="annuler()" style="margin-left: 10px;">{{$t('socialPosts.create.core.cancel')}}</el-button>

        </el-row>
      </div>
    </template>
  </ubi-page-container>
</template>

<script>
import UbiPanel from '@/components/Panel'
import { Upload } from 'element-ui'
import { capitalize } from 'lodash/string'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Emoji from '@/components/emojis/Emoji'
import moment from 'moment'
import PostEditoCreatePublicationInitiale from '@/pages/socialNetworks/components/PostEditoCreatePublicationInitiale'
import PostEditoCreateFacebook from '@/pages/socialNetworks/components/PostEditoCreateFacebook'
import PostEditoCreateInstagram from '@/pages/socialNetworks/components/PostEditoCreateInstagram'
import PostEditoCreateGoogle from '@/pages/socialNetworks/components/PostEditoCreateGoogle'
import PostEditoCreateLinkedin from '@/pages/socialNetworks/components/PostEditoCreateLinkedin'
import DialogPlanifPostEditorial from '@/pages/socialNetworks/components/DialogPlanifPostEditorial'
import PostEditoCreateModalConfirmStopCustom
  from '@/pages/socialNetworks/components/PostEditoCreateModalConfirmStopCustom'
import PostEditoCreateModalIA from '@/pages/socialNetworks/components/PostEditoCreateModalIA'
import DialogPublishNow from '@/pages/socialNetworks/components/DialogPublishNow'
import DialogDeletePlanifBrouillon from '@/pages/socialNetworks/components/DialogDeletePlanifBrouillon.vue'

export default {
  name: 'SocialPostEditorialCreate',
  components: {
    UbiPanel,
    ElUpload: Upload,
    Emoji,
    PostEditoCreatePublicationInitiale,
    PostEditoCreateFacebook,
    PostEditoCreateInstagram,
    PostEditoCreateGoogle,
    PostEditoCreateLinkedin,
    DialogPlanifPostEditorial,
    PostEditoCreateModalConfirmStopCustom,
    PostEditoCreateModalIA,
    DialogPublishNow,
    DialogDeletePlanifBrouillon
  },
  inject: ['browserContext'],
  data () {
    const checkUrl = (rule, value, callback) => {
      const url = this.$store.state.socialPostsCreationPostEditorial.post.initial.linkToVideo
      const regexUrl = new RegExp(
        '^' +
          // protocol identifier (optional)
          // short syntax // still required
          '(?:(?:(?:https?|ftp):)?\\/\\/)' +
          // user:pass BasicAuth (optional)
          '(?:\\S+(?::\\S*)?@)?' +
          '(?:' +
          // IP address exclusion
          // private & local networks
          '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
          '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
          '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broadcast addresses
          // (first & last IP address of each class)
          '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
          '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
          '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
          '|' +
          // host & domain names, may end with dot
          // can be replaced by a shortest alternative
          // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
          '(?:' +
          '(?:' +
          '[a-z0-9\\u00a1-\\uffff]' +
          '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
          ')?' +
          '[a-z0-9\\u00a1-\\uffff]\\.' +
          ')+' +
          // TLD identifier name, may end with dot
          '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
          ')' +
          // port number (optional)
          '(?::\\d{2,5})?' +
          // resource path (optional)
          '(?:[/?#]\\S*)?' +
          '$', 'i'
      )

      // const regexUrl = new RegExp('^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$')
      if (url && !regexUrl.test(url)) {
        return callback(new Error(this.$t('URL Non valide')))
      }
    }
    const checkLibelleInitial = (rule, value, callback) => {
      const libelle = this.$store.state.socialPostsCreationPostEditorial.post.initial.libelle
      if (libelle === null || libelle.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
    }
    const checkTexteInitial = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.initial.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
    }
    const checkTexteFacebook = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.facebook.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
    }
    const checkTexteLinkedIn = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.linkedin.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
    }
    const checkTexteGoogle = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.google.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
    }
    const checkDatesGoogle = (rule, value, callback) => {
      let inputDatesCheck = false
      if (this.$store.state.socialPostsCreationPostEditorial.post.google.offerDateBefore && this.$store.state.socialPostsCreationPostEditorial.post.google.offerDateAfter) {
        inputDatesCheck = true
      }
      if (!inputDatesCheck) {
        return callback(this.$t('validator.isRequired'))
      }
    }
    const checkTexteInstagram = (rule, value, callback) => {
      const inputText = this.$store.state.socialPostsCreationPostEditorial.post.instagram.inputText
      if (!inputText || inputText.length === 0) {
        return callback(this.$t('validator.isRequired'))
      }
    }
    return {
      post: {},
      model: false,
      network: null,
      modalPlanif: false,
      fromReseau: false,
      titleLabel: 'Création',
      typePostInput: null,
      libellePostInput: null,
      title: null,
      texteInput: null,
      promoCodeInput: null,
      offerLinkInput: null,
      offerConditionsInput: null,
      offerBeforeInput: null,
      offerAfterInput: null,
      eventBeforeInput: null,
      eventAfterInput: null,
      actionButtonInput: null,
      offerTimeInput: null,
      promptIA: null,
      eventLinkInput: null,
      sendToStoryInput: false,
      generatedText: null,
      datePlanifInput: null,
      UTMInput: null,
      typePostInstagram: null,
      typePlanif: null,
      redirect: false,
      linkToVideoInstagramInput: null,
      publishToStoryInstagramInput: false,
      legendePhoto: this.$t('socialPosts.create.imageDescription'),
      pickerOptions: {},
      urlPhotoInput: null,
      errors: {},
      rules: {
        texteInputInitial: { validator: checkTexteInitial, trigger: 'blur' },
        texteInputFacebook: { validator: checkTexteFacebook, trigger: 'blur' },
        texteInputInstagram: { validator: checkTexteInstagram, trigger: 'blur' },
        texteInputGoogle: { validator: checkTexteGoogle, trigger: 'blur' },
        texteInputLinkedIn: { validator: checkTexteLinkedIn, trigger: 'blur' },
        libellePostInput: { validator: checkLibelleInitial, trigger: 'blur' },
        // eventAfterInput: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' },
        // eventBeforeInput: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' },
        // eventLinkInput: { validator: checkUrl, trigger: 'blur' },
        urlPhoto: { validator: checkUrl, trigger: 'blur' },
        urlToVideoInitial: { validator: checkUrl, trigger: 'blur' },
        eventDatesGoogle: { validator: checkDatesGoogle, trigger: 'blur' }
        // eventBeforeInputGoogle: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' },
        // eventAfterInputGoogle: { required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }
      }
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial',
      [
        'modalIA',
        'libelle',
        'texte',
        'typePost',
        'photo',
        'edit',
        'create',
        'actionButton',
        'datePlanif',
        'promoCode',
        'eventBefore',
        'eventAfter',
        'offerLink',
        'offerTime',
        'offerConditions',
        'offerBefore',
        'offerAfter',
        'modalIA',
        'loadingStatus',
        'currentPost',
        'redirection',
        'publishButtonAvailable',
        'draftButtonAvailable',
        'modalConfirmPublish',
        'modalDeletePlanifBrouillons'
      ]
    ),
    ...mapGetters('socialPostsCreationPostEditorial', ['getStateDefault']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial', [
      'setLibelle',
      'setTypePost',
      'setTexte',
      'setPhoto',
      'setActionButton',
      'setDatePlanif',
      'setEdit',
      'setCreate',
      'setPromoCode',
      'setEventBefore',
      'setEventAfter',
      'setOfferLink',
      'setOfferTime',
      'setOfferConditions',
      'setOfferBefore',
      'setOfferAfter',
      'setModalIA',
      'setLoadingStatus',
      'setUTM',
      'setPublishToStoryInstagram',
      'setLinkToVideoInstagram',
      'setTypePostInstagram',
      'setEventLink',
      'setNetwork',
      'setLoadingStatusIAGeneration',
      'resetState',
      'setRedirection',
      'setDefaultPost',
      'SET_MODAL_DELETE_PLANIF_BROUILLONS'
    ]),
    ...mapActions('socialPostsCreationPostEditorial',
      ['validatePost']),
    handleRemove (file) {
      console.log(file)
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
    },
    handleDownload (file) {
      console.log(file)
    },
    test () {
      console.log(this.photosInput)
    },
    setError (errorKey, errorMessage) {
      if (errorMessage === 'delete') {
        delete this.errors[errorKey]
      } else {
        this.errors[errorKey] = errorMessage
      }
    },
    handleplanningActions (command) {
      switch (command) {
        case 'schedule':
          this.openModalPublish()
          break
        case 'publishNow':
          // this.onSubmit('A')
          this.openModalPublishNow()
          break
      }
    },
    openModalPublish () {
      this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublish', true)
    },
    openModalPublishNow () {
      this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublishNow', true)
    },
    onSubmit (type) {
      let exit = 0
      this.$refs.formEdito.validate((valid) => {
        if (!valid) {
          this.$message.error('Vous n\'avez pas renseigné tous les champs obligatoires')
          exit = 1
        }
      })
      if (exit === 0) {
        if (type === 'B' && this.post.planifications && this.post.planifications.length > 0) {
          this.SET_MODAL_DELETE_PLANIF_BROUILLONS(true)
        } else {
          this.validatePost({ typePost: type })
        }
      }
    },
    annuler () {
      if (this.$route.name === 'new-post-editorial' && this.post.id) {
        this.$store.dispatch('socialPostsCreationPostEditorial/deletePostEditorial', this.post.id)
      }
      if (this.$route.name === '' && this.post.id) {
        this.$store.dispatch('socialPostsCreationPostEditorial/deletePostEditorial', this.post.id)
      }
      if (this.$route.name === 'post-editorial-modeles-use' && this.post.id) {
        this.$store.dispatch('socialPostsCreationPostEditorial/deletePostEditorial', this.post.id)
      }
      if (this.$route.name === 'post-editorial-modeles-use' || this.$route.name === 'post-editorial-modeles-create' || this.$route.name === 'post-editorial-modeles-edit') {
        this.$router.push({ name: 'post-editorial-modeles' })
      }
      else {
        this.$router.push({ name: 'social-posts' })
      }
    },
    addEmoji (emoji) {
      this.emojiDisplay = true
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaPostEdito.$el.querySelector('.el-textarea__inner')
      let cursorIndex = textarea.selectionEnd
      if (textarea.innerHTML === '' && !this.texteInput) {
        textarea.innerHTML += insertText
      }
      if (this.post.texteInput) {
        this.post.texteInput = this.texteInput.substring(0, cursorIndex) + insertText + this.texteInput.substring(cursorIndex)
      }
      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    }
  },
  watch: {
    redirection: function () {
      if (this.$route.name === 'post-editorial-modeles-use' || this.$route.name === 'post-editorial-modeles-create' || this.$route.name === 'post-editorial-modeles-edit') {
        this.$router.push({ name: 'post-editorial-modeles' })
      }
      else {
        this.$router.push({ name: 'social-posts' })
      }
    }
  },
  mounted () {
    this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState')
    this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState')
  },
  beforeRouteLeave (to, from, next) {
    if (this.redirection === false) {
      const answer = window.confirm('Vous êtes sur le point de quitter ce formulaire de création d\'un post sans l\'avoir enregistré. Souhaitez-vous vraiment annuler votre création de post ?')
      if (answer) {
        this.$store.commit('socialPostsCreationPostEditorial/resetPost')
        this.$store.commit('socialPostsCreationPostEditorial/setCustomFacebook', false)
        this.$store.commit('socialPostsCreationPostEditorial/setCustomGoogle', false)
        this.$store.commit('socialPostsCreationPostEditorial/setCustomInstagram', false)
        this.$store.commit('socialPostsCreationPostEditorial/setCustomLinkedIn', false)
        this.$store.commit('socialPostsCreationPostEditorial/setFacebookChecked', false)
        this.$store.commit('socialPostsCreationPostEditorial/setInstagramChecked', false)
        this.$store.commit('socialPostsCreationPostEditorial/setGoogleChecked', false)
        this.$store.commit('socialPostsCreationPostEditorial/setLinkedInChecked', false)
        next()
      }
    } else {
      this.$store.commit('socialPostsCreationPostEditorial/resetPost')
      next()
    }
  },
  beforeMount () {
    this.setRedirection(false)
    this.$store.commit('socialPostsCreationPostEditorial/setModalConfirmPublishNow', false)
    this.$store.commit('socialPostsCreationPostEditorial/SET_MODAL_DELETE_PLANIF_BROUILLONS', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomFacebook', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomGoogle', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomInstagram', false)
    this.$store.commit('socialPostsCreationPostEditorial/setCustomLinkedIn', false)
    this.$store.commit('socialPostsCreationPostEditorial/setFacebookChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/setInstagramChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/setLinkedInChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/setGoogleChecked', false)
    this.$store.commit('socialPostsCreationPostEditorial/resetPost')
    this.$store.commit('socialPostsCreationPostEditorial/setCurrentPost', null)
    this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState')

    this.post = this.$store.getters['socialPostsCreationPostEditorial/getPost']
    this.$route.meta.title = this.$t('routes.managePosts')
    this.post.typePlanif = 'publier'
    if (this.$route.params.id && this.$route.name === 'edit-post-editorial') {
      this.setCreate(false)
      this.setEdit(true)
      this.$store.dispatch('socialPostsCreationPostEditorial/loadSocialPostEditorialById', this.$route.params.id)
    } else if (this.$route.name === 'post-editorial-modeles-use' && this.$route.params.id) {
      if (this.$route.params.login !== this.sitimmoUser.login) {
        this.fromReseau = true
      }
      this.$store.dispatch('socialPostsCreationPostEditorial/createPostFromModel', { id: this.$route.params.id, reference: this.$route.params.reference, fromReseau: this.fromReseau })
      this.setCreate(false)
      this.setEdit(true)
    } else if (this.$route.name === 'post-editorial-modeles-create') {
      this.setCreate(true)
      this.setEdit(false)
      this.model = true
    } else if (this.$route.name === 'post-editorial-modeles-edit' && this.$route.params.id) {
      this.$store.dispatch('socialPostsCreationPostEditorial/loadSocialPostEditorialById', this.$route.params.id)
      this.setCreate(false)
      this.setEdit(true)
      this.model = true
    } else {
      this.setCreate(true)
      this.setEdit(false)
      this.$store.commit('socialPostsCreationPostEditorial/setId', null)
      this.post = this.$store.getters['socialPostsCreationPostEditorial/getDefaultPost']
    }
    if (this.create === false) {
      this.titleLabel = 'Edition'
    } else {
      this.resetState()
    }
  }
}
</script>

<style scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0px;
  right: 10px;
}
</style>
<style>
.el-form-item__label {
  font-weight: bold;
}
</style>
